/** Recoil state — the client 'seam': viewer → their clientId; uber → picker. */
import { atom, selector } from 'recoil';
import { api } from './api.js';

export interface Me {
  username: string;
  displayName: string;
  role: 'uber' | 'viewer';
  clientId: string | null;
}

export const authVersionState = atom({ key: 'authVersion', default: 0 });

export const meState = selector<Me | null>({
  key: 'me',
  get: async ({ get }) => {
    get(authVersionState); // re-fetch on login/logout
    try {
      return await api.get<Me>('/me'); // session cookie OR dev stub header
    } catch {
      return null;
    }
  },
});

/** Uber account-switch (viewer ignores this — the server scopes by RLS anyway). */
export const pickedClientState = atom<string | null>({ key: 'pickedClient', default: null });

export const activeClientState = selector<string | null>({
  key: 'activeClient',
  get: ({ get }) => {
    const me = get(meState);
    if (!me) return null;
    return me.role === 'viewer' ? me.clientId : get(pickedClientState);
  },
});

export const selectedFundState = atom<string | null>({ key: 'selectedFund', default: null });

/** Report cutoff date (YYYY-MM-DD) — null = latest/current month, today's behavior. */
export const reportCutoffState = atom<string | null>({ key: 'reportCutoff', default: null });

/** Bump to refetch data after ingestion/admin changes. */
export const dataVersionState = atom({ key: 'dataVersion', default: 0 });
